import { render, staticRenderFns } from "./RGFooter.vue?vue&type=template&id=1984f4a4"
import script from "./RGFooter.vue?vue&type=script&lang=js"
export * from "./RGFooter.vue?vue&type=script&lang=js"
import style0 from "./RGFooter.vue?vue&type=style&index=0&id=1984f4a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports